import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useSessionId, ThemeContext, useAuthProvider, callApi } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';

import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from "@azure/msal-react";
import { Account } from "../types";


const StandardApi = (props) => {
    const [ authorized, authType ] = useAuthProvider();
    const navigate = useNavigate();
    const defaultState = {
        accountId: '',
        account: null,
        loading: false,
        errors: null
    };

    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);
    React.useEffect(() => {
        if(authorized && (authType !== "salesforce")){
            return navigate("/auth-not-supported", { replace: true });
        }
    });
    function handleChange(event, name){
        setState({
            [name]: event.currentTarget.value
        });
    }
    function loadAccountInfo(){
        const queue: Account = {
            sObjectTypeName: 'Account',
            url: "/sobjects/Account/"+state.accountId,
            method: 'GET',
            headers: {},
            data: {}
        };

        callApi('salesforceapi', queue).then((response: any) => {
            setState({
                account: response,
                loading: false,
                errors: null
            });
        }).catch((err) => {
            console.log(err);
            let errorMessage = null;
            if(typeof(err) === "object" && err.hasOwnProperty("error")){
                errorMessage = err.error;
            }else if(typeof(err) === "object" && err.hasOwnProperty("message")){
                errorMessage = err.message;
            }else if(Array.isArray(err)){
                errorMessage = err;
            }
            setState({
                account: null,
                loading: false,
                errors: errorMessage
            });
        });

        setState({
            loading: true,
            account: null,
            errors: null
        });
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={3}>
                <Grid container justifyContent="flex-start" alignItems="flex-start">
                    <Grid item xs={8} md={6} lg={6} mr={2}>
                        <MDInput
                            label="Account Id"
                            value={state.accountId}
                            fullWidth
                            onChange={(event: any) => handleChange(event, "accountId")}
                        />
                    </Grid>
                    <Grid item xs={3} md={5} lg={5}>
                        <MDButton variant="gradient" color="info" onClick={loadAccountInfo}>
                            Get Account
                        </MDButton>
                    </Grid>
                </Grid>
            </MDBox>
            {
                state.errors !== null ?
                    <MDBox my={3}>
                        <Grid container justifyContent="flex-start" alignItems="flex-start">
                            <Grid item xs={8} md={6} lg={6} mr={2}>
                                {
                                    state.errors.map((error, key) => {
                                        return (
                                            <Alert
                                                key={key}
                                                severity="error"
                                            >{error.message}</Alert>
                                        )
                                    })
                                }
                            </Grid>
                        </Grid>
                        
                    </MDBox>
                :
                null
            }
            <MDBox my={3}>
                {
                    state.account !== null ?
                        state.account.Name
                    :
                        state.loading ?
                            <CircularProgress color="info"/>
                        :
                        null
                }
            </MDBox>
        </DashboardLayout>
    )
}

export default StandardApi;